import React from 'react';

import ProductPrice from 'components/ProductPrice';
import { Button } from 'ui-components/v2/Button';
import { HookFormProps, PDPProps } from 'pages/pdp/interface';
import { PurchaseFormFieldNames as FIELD_NAMES } from 'constants/form';

interface DualCheckoutButtonsProps {
  subtotal: string;
  disabled: boolean;
  isBottomBar: boolean;
  salesSubtotal: string | null;
}

export const DualCheckoutButtons = ({
  product,
  subtotal,
  salesSubtotal,
  disabled,
  onSubmit,
  setValue,
  isBottomBar,
  handleSubmit,
}: DualCheckoutButtonsProps &
  Pick<PDPProps, 'product'> &
  Omit<HookFormProps, 'control' | 'loading' | 'submitError'>) => {
  const handleRegularCheckout = () => {
    setValue(FIELD_NAMES.withRouteInsurance, false);
    handleSubmit(onSubmit)();
  };

  const handleRouteCheckout = () => {
    setValue(FIELD_NAMES.withRouteInsurance, true);
    handleSubmit(onSubmit)();
  };

  return (
    <div
      className={`${isBottomBar ? 'flex-col sm:flex-row-reverse' : 'flex-col'} flex w-full gap-3`}
    >
      <Button
        fullWidth
        color="primary"
        variant="contained"
        className={`tracking-add-to-cart-with-route ${isBottomBar ? '!h-[60px] sm:!px-8' : '!h-auto'}`}
        disabled={disabled}
        onClick={handleRouteCheckout}
        tabIndex={isBottomBar ? -1 : undefined}
      >
        <span className="flex flex-col items-center">
          <span className="text-base font-medium">
            Add To Cart -{' '}
            <ProductPrice price={subtotal} salesPrice={salesSubtotal} />
          </span>
          <span className="text-sm">
            +${product.route_product_price} package protection
          </span>
        </span>
      </Button>
      <Button
        fullWidth
        color="secondary"
        variant="contained"
        className={`tracking-add-to-cart ${isBottomBar ? '!h-[42px] sm:!h-[60px]' : ''}`}
        disabled={disabled}
        onClick={handleRegularCheckout}
        tabIndex={isBottomBar ? -1 : undefined}
      >
        Add To Cart
      </Button>
    </div>
  );
};
